import { AiOutlineSearch } from "react-icons/ai";
import React, { useState, useEffect } from "react";
import { FaBriefcase, FaMapMarkerAlt, FaCheck } from "react-icons/fa";
import { jobApi } from "../../API/Api";
import { useLocation } from "react-router-dom";

const JobListing = () => {
  const locationObj = useLocation();
  const searchParams = new URLSearchParams(locationObj.search);

  // Pre-populate filters from URL
  const [job, setJob] = useState(searchParams.get("job") || "");
  const [location, setLocation] = useState(searchParams.get("location") || "");
  const [experience, setExperience] = useState(
    searchParams.get("experience") || ""
  );

  // Jobs from API
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [meta, setMeta] = useState({});

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 3;

  // Selected job state
  const [selectedJob, setSelectedJob] = useState(null);
  const [bookmarked, setBookmarked] = useState(false);

  // Fetch jobs from backend
  const fetchJobs = async () => {
    try {
      const res = await jobApi.getJobs(currentPage, jobsPerPage);
      setJobs(res.data);
      setFilteredJobs(res.data);
      setMeta(res.meta);
      if (res.data.length > 0) setSelectedJob(res.data[0]);
    } catch (err) {
      console.error("Error fetching jobs:", err);
    }
  };
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await jobApi.getJobs(currentPage, jobsPerPage);
        const jobsData = Array.isArray(res.data) ? res.data : [];
        setJobs(jobsData);
        setFilteredJobs(jobsData);
        setMeta(res.meta || {});
        if (jobsData.length > 0) setSelectedJob(jobsData[0]);

        // Apply filters from URL
        handleSearch(jobsData);
      } catch (err) {
        console.error("Error fetching jobs:", err);
      }
    };

    fetchJobs();
  }, []);

  useEffect(() => {
    fetchJobs();
  }, [currentPage]);

  // Apply filters
  // Add new state for additional filters
  const [currentLocation, setCurrentLocation] = useState("");
  const [profileFilter, setProfileFilter] = useState("");
  const [rolesFilter, setRolesFilter] = useState("");

  // Updated handleSearch
  const handleSearch = (jobsArray = jobs) => {
    // Ensure jobsArray is an array
    const arr = Array.isArray(jobsArray) ? jobsArray : [];

    const filtered = arr.filter((j) => {
      const matchJob =
        !job || (j.position || "").toLowerCase().includes(job.toLowerCase());
      const matchLocation =
        !location ||
        (j.locationsPreferred || []).some((loc) =>
          loc.toLowerCase().includes(location.toLowerCase())
        );
      const matchExperience =
        !experience ||
        (j.experience || "").toLowerCase().includes(experience.toLowerCase());

      return matchJob && matchLocation && matchExperience;
    });

    setFilteredJobs(filtered);
    setCurrentPage(1);
    setSelectedJob(filtered.length > 0 ? filtered[0] : null);
  };

  // Pagination logic
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    const firstJob = filteredJobs[(pageNumber - 1) * jobsPerPage];
    if (firstJob) setSelectedJob(firstJob);
  };

  return (
    <>
      {/* Search Section */}
      <section className="serch-job">
        <div className="container">
          <div className="search-box">
            <h1 className="text-center-1">Job Search</h1>

            {/* Job Position Dropdown */}
            <select
              className="form-control"
              value={job}
              onChange={(e) => setJob(e.target.value)}
            >
              <option value="">Search by Job</option>
              {[...new Set(jobs.map((j) => j.position))].map((pos) => (
                <option key={pos} value={pos}>
                  {pos}
                </option>
              ))}
            </select>

            {/* Location Dropdown */}
            <select
              className="form-control"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            >
              <option value="">Location</option>
              {[...new Set(jobs.flatMap((j) => j.locationsPreferred))].map(
                (loc) => (
                  <option key={loc} value={loc}>
                    {loc}
                  </option>
                )
              )}
            </select>

            {/* Experience Dropdown */}
            <select
              className="form-control"
              value={experience}
              onChange={(e) => setExperience(e.target.value)}
            >
              <option value="">Experience</option>
              {[...new Set(jobs.map((j) => j.experience))].map((exp) => (
                <option key={exp} value={exp}>
                  {exp}
                </option>
              ))}
            </select>

            <button
              className="btn btn-purple-1 text-white"
              onClick={() => handleSearch(jobs)}
            >
              <AiOutlineSearch
                style={{ width: "24px", height: "24px", rotate: "90deg" }}
              />
            </button>
          </div>
        </div>
      </section>

      {/* Filter Buttons
      <section className="serch-all d-flex">
        <div className="container mt-4">
          <div className="btn-filter-group" role="group">
            <button className="btn btn-outline-purple rounded-pill">
              Location <FaArrowRight className="ms-2" />
            </button>
            <button className="btn btn-outline-purple rounded-pill">
              Industry <FaArrowRight className="ms-2" />
            </button>
            <button className="btn btn-outline-purple rounded-pill">
              Role <FaArrowRight className="ms-2" />
            </button>
            <button className="btn btn-outline-purple rounded-pill">
              Job Type <FaArrowRight className="ms-2" />
            </button>
            <button className="btn btn-outline-purple rounded-pill">
              All Filters <FaFilter className="ms-2" style={{ rotate: "90deg" }} />
            </button>
          </div>
        </div>
      </section> */}

      {/* Job Cards Section */}
      <section className="card-Aall">
        <div className="job-cards-container">
          {/* Jobs list */}
          <nav className="jobs-list">
            {currentJobs.length > 0 ? (
              currentJobs.map((job) => (
                <div
                  key={job.id}
                  tabIndex="0"
                  className={`job-list-item ${
                    selectedJob?.id === job.id ? "selected" : ""
                  }`}
                  role="button"
                  onClick={() => setSelectedJob(job)}
                >
                  <div className="job-header">
                    <span className="job-icon">
                      <FaBriefcase style={{ rotate: "90deg", width: "24px" }} />
                    </span>
                    <div className="job-info">
                      <span className="job-title">{job.position}</span>
                      <span className="job-location">
                        {job.currentLocation}
                      </span>
                    </div>
                  </div>
                  <div className="job-meta">
                    <div className="meta-item">
                      <FaBriefcase
                        className="me-1"
                        style={{ rotate: "90deg", width: "16px" }}
                      />
                      {job.experience}
                    </div>
                    <div className="meta-item">
                      <FaMapMarkerAlt
                        className="me-1"
                        style={{ rotate: "90deg", width: "16px" }}
                      />
                      {job.locationsPreferred.join(", ")}
                    </div>
                    <div className="posted">
                      <small>
                        {new Date(job.createdAt).toLocaleDateString()}
                      </small>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No jobs found.</p>
            )}

            {/* Pagination */}
            {filteredJobs.length > 0 && (
              <div className="container mt-5">
                <nav>
                  <ul className="pagination justify-content-center gap-3">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        &laquo;
                      </button>
                    </li>
                    {Array.from({ length: totalPages }, (_, i) => (
                      <li
                        key={i + 1}
                        className={`page-item ${
                          currentPage === i + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(i + 1)}
                        >
                          {i + 1}
                        </button>
                      </li>
                    ))}
                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        &raquo;
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </nav>

          {/* Details Panel */}
          {selectedJob && (
            <section className="details-panel">
              <header className="details-header">
                <div className="details-icon">
                  <FaBriefcase style={{ rotate: "90deg", width: "24px" }} />
                </div>
                <h1 className="details-title">{selectedJob.position}</h1>
                <button
                  className="bookmark-icon"
                  onClick={() => setBookmarked(!bookmarked)}
                >
                  {bookmarked ? "★" : "☆"}
                </button>
              </header>

              <div className="small-info">
                <span>
                  <small>
                    {new Date(selectedJob.createdAt).toLocaleDateString()}
                  </small>
                </span>
                <span>
                  <small>Early applications get noticed first</small>
                </span>
              </div>

              <div className="location-info">
                <div>
                  <FaBriefcase
                    className="me-1"
                    style={{ rotate: "90deg", width: "24px", height: "24px" }}
                  />
                  {selectedJob.experience}
                </div>
                <div>
                  <FaMapMarkerAlt
                    className="me-1"
                    style={{ rotate: "90deg", width: "24px", height: "24px" }}
                  />
                  {selectedJob.locationsPreferred.join(", ")}
                </div>
              </div>
              <button className="btn-apply" type="button">
                Apply Now
              </button>

              <div>
                <h2 className="section-title">Job Description</h2>
                <p>{selectedJob.jobDescription}</p>
                <h3 className="sub-title">Preferred Candidate Profile</h3>
                <ul className="description-list">
                  {selectedJob.profile?.map((r, i) => (
                    <li key={i}>
                      <FaCheck
                        className="me-1"
                        style={{
                          rotate: "90deg",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                      {r}
                    </li>
                  ))}
                </ul>

                <h3 className="sub-title">Roles & Responsibilities</h3>
                <ul className="description-list">
                  {selectedJob?.responsibilities?.map((r, i) => (
                    <li key={i}>
                      <FaCheck
                        className="me-1"
                        style={{
                          rotate: "90deg",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                      {r}
                    </li>
                  ))}
                </ul>

                <button className="btn-more-info" type="button">
                  More Info
                </button>
              </div>
            </section>
          )}
        </div>
      </section>
    </>
  );
};

export default JobListing;
